import './changes-config.scss';
import { useLazyQuery, useQuery } from '@apollo/client';
import { CLASSES_BRANCH, CLASS_BY_BRANCH } from '../shared/graphql/branch';
import debounce from 'lodash.debounce';
import { useState, useEffect, useRef } from 'react';
import set from 'date-fns/set';
import format from 'date-fns/format';
import ClassesBranchView from '../class-branch/views/classes-branch-view';
import { Titles } from '../shared/components/titles/titles';
import { DaysSwiper } from '../shared/components/days-swiper/days-swiper';
import { SkeletonClassBranches } from '../shared/components/skeleton-class-branches/skeleton-class-branches';
import Grid from '@mui/material/Grid';
// import Slider from '@mui/material/Slider';
import SearchIcon from '@mui/icons-material/Search';
import TakeAttendance from '../take-attendance/take-attendance';
import TextField from '@mui/material/TextField';
import {  InputAdornment } from '@mui/material';
import { TITLE_CLASS_BRANCH } from '../class-branch/constants/title';
import Button from '@mui/material/Button';
import ModalDetailedClass from './modal-edit/modal-detailed-class';
import ModalCreateClass from './modal-edit/modal-create-class';


let classsesByBranch: any = []
let classsesByBranchTotal: any = []
let branchActive: number;
let page: number = 0;

export default function ClassBranch({ branch }: { branch: number }) {
    console.log("🚀 ~ ClassBranch ~ branch:", branch);

    
    const [textSearch, setSearch] = useState<string>('');
    const [calendarSelected, changeCalendar] = useState(null);
    let [checkStudents] = useState(false);
    const [valueSlider] = useState<number[]>([0, 23]);
    const [buttonText, setButtonText] = useState('Ver por fecha');
    const [isModalDetailedClass, setIsModalDetailedClass] = useState(false);
    const [idClassSelected, setIdClassSelected] = useState(0);
    const [isModalCreateClass, setIsModalCreateClass] = useState(false);
    const [selectedDateForNewClass, setSelectedDateForNewClass] = useState<string>('');
    
    
    const handleToggleEditClassModal = (id:number) => {
        setIsModalDetailedClass(isModalDetailedClass => !isModalDetailedClass);
        setIdClassSelected(id);
        
      };

    const handleToggleCreateClassModal = (date: string) => {
        setIsModalCreateClass(!isModalCreateClass);
        setSelectedDateForNewClass(date);
        
        if (!isModalCreateClass) {
            getClassByBranch({
                variables: {
                    branchId: branch,
                    term: " "
                }
            });
        }
    };

    const handleScheduleCreated = async () => {
        await refetchClasses();
        reload(true);
    };
      
      
    let hasPendingAttendance = false;
      
    let [filters, changeFilters] = useState({
        branchId: branch,
        date: new Date().toDateString(),
        searchTerm: '',
        startTime: '',
        endTime: '',
        page: page,
        perPage: 10,
        inscribedFrom: checkStudents ? 1 : null,
    });
        
    const filtersRef = useRef(filters);
    filters.branchId = branch;
    filters.inscribedFrom = checkStudents ? 1 : null;
    const classIds: number[] = [];
    const quotas: number[] = [];
    classsesByBranch = [];
    classsesByBranchTotal = [];

    const { data: classesData, loading: classesLoading, fetchMore: classesFetchMore, refetch: refetchClasses } = useQuery(CLASSES_BRANCH, { 
        variables: filters
    });

    const [getClassByBranch, { data: dataByBranch }] = useLazyQuery(CLASS_BY_BRANCH);

    if (classesData) {
        classsesByBranch = classesData.classesDayByBranchIdPaginate;
        // capacityClasses = classsesByBranch.data.map((el: any) => el.capacity);
        classsesByBranch.data.forEach((el: any) => {
            if (el.reservations && el.reservations.some((ele: any) => ele.statusId === 1)) {
                hasPendingAttendance = true;
            }
        });
    }

    let [filtersTotal, changeFiltersTotal] = useState({
        branchId: branch,
        date: new Date().toDateString(),
        searchTerm: '',
        startTime: '',
        endTime: '',
        page: page,
        perPage: classsesByBranch.total,
        inscribedFrom: checkStudents ? 1 : null,
    });

    const { data: totalClassesData } = useQuery(CLASSES_BRANCH, { variables: filtersTotal });

    if (totalClassesData) {
        classsesByBranchTotal = totalClassesData.classesDayByBranchIdPaginate;
        classsesByBranchTotal.data.map((clase: any) => {
            if (clase.id) {
                classIds.push(clase.id);
                quotas.push(clase.capacity);
            }
            return clase;
        });
    }

    let initialDaysArr = [{}, {}, {}, {}, {}, {}, {}, {}];
    let [days, changeDays] = useState(initialDaysArr);
    const weekdays = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

    if (branchActive !== branch) {
        branchActive = branch;
        classsesByBranch = [];
        classsesByBranchTotal = [];
    }

    useEffect(() => {
        page = 1;
    }, [branch]);

    useEffect(() => {
        filtersRef.current = filters;
    }, [filters]);

    const fetchMoreData = () => {
        page = page + 1;
        classesFetchMore({
            variables: { ...filters, page: page }, updateQuery: (previousQueryResult, { fetchMoreResult }) => {
                fetchMoreResult.classesDayByBranchIdPaginate.data = [
                    ...previousQueryResult.classesDayByBranchIdPaginate.data,
                    ...fetchMoreResult.classesDayByBranchIdPaginate.data,
                ];
                return fetchMoreResult;
            }
        });
    };

    function refreshDays(i: number) {
        let end = new Date();
        const day = new Date();
        end.setDate(end.getDate() + 15);
        const daysAux = [];

        while (day < end) {
            daysAux.push({
                date: new Date(day),
                weekDay: weekdays[new Date(day).getDay()],
                monthDay: day.getDate(),
                month: months[new Date(day).getMonth()],
                active: false,
            });
            day.setDate(day.getDate() + 1);
        }

        daysAux[i].active = true;
        filters.date = daysAux[i].date.toDateString();
        let range1: any = set(new Date(filters.date), { hours: valueSlider[0], minutes: 0, seconds: 0 });
        range1 = format(range1, "yyyy-MM-dd'T'HH:mm:ss");
        let range2: any = set(new Date(filters.date), { hours: valueSlider[1], minutes: 59, seconds: 59 });
        range2 = format(range2, "yyyy-MM-dd'T'HH:mm:ss");
        page = 1;
        changeFilters({
            branchId: branch,
            date: filters.date,
            searchTerm: textSearch,
            startTime: range1,
            endTime: range2,
            page: page,
            perPage: 10,
            inscribedFrom: checkStudents ? 1 : null,
        });

        changeFiltersTotal({
            branchId: branch,
            date: filters.date,
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: page,
            perPage: classsesByBranch.total,
            inscribedFrom: checkStudents ? 1 : null,
        });

        changeDays(daysAux);
    }

    function reload(reload: boolean) {
        page = reload ? 1 : page;
        changeFilters({
            branchId: branch,
            date: filters.date,
            searchTerm: filters.searchTerm,
            startTime: filters.startTime,
            endTime: filters.endTime,
            page: page,
            perPage: 10,
            inscribedFrom: filters.inscribedFrom,
        });

        changeFiltersTotal({
            branchId: branch,
            date: filters.date,
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: page,
            perPage: classsesByBranch.total,
            inscribedFrom: checkStudents ? 1 : null,
        });
    }

    // function valueLabelFormat(value: number) {
    //     return `${value}H`;
    // }

    // const callbackRange = (newValue: number[]) => {
    //     let range1: any = set(new Date(filters.date), { hours: newValue[0], minutes: 0, seconds: 0 });
    //     range1 = format(range1, "yyyy-MM-dd'T'HH:mm:ss");
    //     let range2: any = set(new Date(filters.date), { hours: newValue[1], minutes: 59, seconds: 59 });
    //     range2 = format(range2, "yyyy-MM-dd'T'HH:mm:ss");

    //     filters.startTime = range1;
    //     filters.endTime = range2;

    //     reload(true);
    // }

    // const delayedRange = useCallback(
    //     debounce((newValue: number[]) => callbackRange(newValue), 600),
    //     []
    // );

    // const debouncedRangeChange = (event: Event, newValue: number | number[]) => {
    //     setValue(newValue as number[]);
    //     delayedRange(newValue as number[]);
    // };

    // const callbackSearch = (text: string) => {
    //     // filters.searchTerm = text;
    //     filtersRef.current.searchTerm = text;
    //     reload(true);
    // }
    const debouncedSearch = useRef(
        debounce((text: string) => {
            filtersRef.current.searchTerm = text;
            reload(true);
        }, 600)
    ).current;

    const changeSearch = (e: any) => {
        setSearch(e.target.value);
        debouncedSearch(e.target.value);
    };

    // const handleClick = () => {
    //     changeStudents(checkStudents ? false : true);
    //     filters.inscribedFrom = checkStudents ? null : 1;
    // };

    const handleChangeTakeAttendance = (dataCalendar: any) => {
        changeCalendar(dataCalendar)
    }
    const resetView = () => {
        classsesByBranch = [];
        classsesByBranchTotal = [];
        changeCalendar(null)
    }

    const handleAddAndCancelQuotas = (message: any) => {
        page = 1;
        changeFilters({
            branchId: branch,
            date: new Date().toDateString(),
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: page,
            perPage: 10,
            inscribedFrom: checkStudents ? 1 : null,
        });
        console.log('Action:', message);
    };


    const buttonChangueView = () => {
        setButtonText(buttonText === 'Ver por fecha' ? 'Ver por horario' : 'Ver por fecha');

        getClassByBranch({
            variables: {
                branchId: branch,
                term: "", 
            }
        });

        
    
    }

    return (
        <div className="section-menu internal-container">
            <div className={`container-cards-classes ${hasPendingAttendance ? 'is-pending-attendance' : ''}`} >

               
                <Titles props={TITLE_CLASS_BRANCH}></Titles>
                {calendarSelected ?
                    <TakeAttendance attendance={resetView} dataCalendar={calendarSelected} /> :
                    <div>
                        
                        <Grid container className="filters-box">
                            <Grid item xs={4} md={4} className='container-search-bar'>
                                <TextField className="input-search" placeholder="¿Qué buscas?" onChange={changeSearch}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" className="input-search-icon">
                                                <SearchIcon />
                                            </InputAdornment>
                                        )
                                    }} />
                            </Grid>
                            {/* <Grid item xs={5} md={5} className="container-slider">
                                <Slider value={valueSlider} onChange={debouncedRangeChange} size="small"
                                    valueLabelDisplay="on" valueLabelFormat={valueLabelFormat} min={0} max={23} marks />
                            </Grid> */}

                            <Grid item xs={4} md={4} className="container-slider">
                                <Button onClick={buttonChangueView}>
                                        <span>{buttonText}</span>
                                </Button>
                            </Grid>
                        </Grid>

                        
                        {buttonText === "Ver por fecha" ?
                         (
                        <div>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <p>Vista por horario</p>
                                </Grid>
                                <Grid item>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={() => handleToggleCreateClassModal(filters.date)}
                                        style={{ marginRight: '16px' }}
                                    >
                                        Crear horario
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mt={5} className="container-swiper">
                                <DaysSwiper days={days} clickedDay={(i: number) => refreshDays(i)} />
                            </Grid>

                            {(classesLoading) && (
                                <SkeletonClassBranches />
                            )}
                            {(classsesByBranch && !classesLoading) && (
                                <ClassesBranchView dataInput={classsesByBranch} classIds={classIds} quotas={quotas} onEventAddClose={handleAddAndCancelQuotas} fetchMoreData={() => fetchMoreData()} updateData={() => reload(true)} checkBooks={(e) => handleChangeTakeAttendance(e)} edit={true} />
                            )}

                            <ModalCreateClass 
                                open={isModalCreateClass} 
                                handleClose={() => handleToggleCreateClassModal('')} 
                                availableClasses={dataByBranch?.classes || []}
                                selectedDate={selectedDateForNewClass}
                                onScheduleCreated={handleScheduleCreated}
                            />
                            </div>
                        ):null
                        }

                        {buttonText === "Ver por horario" && dataByBranch ?
                            (
                                <div>
                                    <p>Vista por clase</p>
                                    <div className='containerOptionClass'>
                                        {dataByBranch.classes.map((clase: any, index: number) => (
                                            <div>
                                            <button onClick={() => handleToggleEditClassModal(clase.id)} className='OptionClass' key={index}>
                                                <p>{clase.name}</p>
                                            </button>

                                            <ModalDetailedClass 
                                            open={isModalDetailedClass} 
                                            handleClose={() => handleToggleEditClassModal(0)} 
                                            classId={idClassSelected} 
                                            />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null
                        }
                        


                    </div>
                }
            </div>
        </div>
    );
}
